// const  BASE_URL ='https://iceroboapi.pickupbiz.in/api/v1'
// const  BASE_URL ='https://iceroboapi.pickupbiz.in/api/v1'
// const  BASE_URL =process.env.NEXT_PUBLIC_BASEURL
// const  BASE_URL ='https://iceroboapi.pickupbiz.in/api/v1'
// const  BASE_URL ='https://iceroboapi.pickupbiz.in/api/v1'
const BASE_URL ="https://iceroboapi.pickupbiz.in/api/v1"
export default BASE_URL;